import { Icon, IconProps } from "../Icon";

const Delete = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 2H12V4H20V2ZM4 6V8H6V28C6 29.1046 6.89543 30 8 30H24C25.1046 30 26 29.1046 26 28V8H28V6H4ZM8 28V8H24V28H8ZM12 12H14V24H12V12ZM20 12H18V24H20V12Z"
      fill="currentColor"
    />
  </Icon>
);

export default Delete;
